import { AuthData } from "api/resources/users/types"
import { GA } from "utils/googleAnalytics"
import { webengage } from "webengage"
import { COURSE_SLUGS, QUALIFICATION_SLUGS } from "./constants"
import { getPlatformURL } from "./helpers"

export const trackUser = (
  authInfo: AuthData,
  options?: { timeout?: number }
) => {
  try {
    if (webengage) {
      webengage.user.login(authInfo.user.uuid)
      webengage.user.setAttribute("we_email", authInfo.user.email)
      webengage.user.setAttribute("we_first_name", authInfo.user.firstName)
      webengage.user.setAttribute("we_last_name", authInfo.user.lastName)
    }

    setTimeout(() => {
      GA.setUserId(authInfo.user.uuid)
    }, options?.timeout || 0)
  } catch (e) {
    console.error(e)
  }
}

export const getProductPageLink = (slug: string, fallback: string) => {
  switch (slug) {
    case QUALIFICATION_SLUGS.pgctl:
      return getPlatformURL("suraasa", `/qualifications/${slug}`)
    case COURSE_SLUGS.english:
      return getPlatformURL("suraasa", `/courses/${slug}`)
    default:
      return fallback
  }
}
